/* eslint-disable */

import { type SVGProps } from "react";
import { cn } from "../../lib/utils";

export function PlatformContent({
  className,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={cn("w-[1em] h-[1em]", className)}
      viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      
  <path d="M13.382 4.06a1.334 1.334 0 0 1 1.134 1.505l-1.187 8.45a1.334 1.334 0 0 1-1.506 1.135l-6.866-.965a1.333 1.333 0 0 1-1.146-1.383h6.056A2.134 2.134 0 0 0 12 10.668V3.865l1.382.195Zm-2.242 7.005a1.334 1.334 0 0 1-1.273.937h-5.95v-.001h5.95c.598 0 1.105-.395 1.273-.938v.002Zm.06-.397c0 .046-.002.092-.007.137l-.02.132c.017-.087.027-.178.027-.27v.001Z" fill="#FFAAA3"></path>
  <path d="M9.866.8c.737 0 1.333.598 1.334 1.334v8.533c0 .736-.597 1.334-1.334 1.334H2.933A1.334 1.334 0 0 1 1.6 10.667V2.134C1.6 1.398 2.197.8 2.933.8h6.933ZM4.8 8.474a.4.4 0 0 0 0 .8H8a.4.4 0 0 0 0-.8H4.8ZM7.263 3c-.35 0-.664.16-.863.411a1.1 1.1 0 0 0-.863-.411c-.594 0-1.087.465-1.087 1.05 0 .785.488 1.422.948 1.851a5.042 5.042 0 0 0 .848.635l.06.034.017.01.004.002h.002a.152.152 0 0 0 .142 0l.006-.003.016-.009.06-.034a5.04 5.04 0 0 0 .85-.635c.46-.429.947-1.066.947-1.85 0-.586-.492-1.05-1.087-1.051Z" fill="#EC5D51"></path>

    </svg>
  );
}
